module.exports = __webpack_public_path__ + "static/media/paco-rabanne-black-xs-big.f1f5f228.png";